export default __webpack_public_path__ + "static/media/image-hero-mobile.d4f477d4.jpg";